import { useTranslation } from "react-i18next";

const LegalSimpliFooter = ({ privacyPolicy, termsOfUse, contactUs }) => {
  const { t } = useTranslation();
  return (
    <div className="legalsimpli-footer h-16 md:pb-0">
      <div className="flex justify-center gap-x-4 text-[#16283D] font-normal text-sm md:text-base pb-1 !font-rethink">
        <a class="hidden md:block" href={privacyPolicy}>
          {t("footer.ls.privacy_policy")}
        </a>
        <a class="block md:hidden" href={contactUs}>
          {t("footer.ls.contact_us")}
        </a>
        <a className="pl-2 border-l border-[#16283D]" href={termsOfUse}>
          {t("footer.ls.terms_condition")}{" "}
        </a>
        <a className="pl-3 hidden md:block border-l border-[#16283D]" href={contactUs}>
          {t("footer.ls.contact_us")}
        </a>
        <a class="pl-3 block md:hidden border-l border-[#16283D]" href={privacyPolicy}>
          {t("footer.ls.privacy_policy")}
        </a>
      </div>

      <div className="text-center text-[#16283D] text-xs md:text-base p-2 font-normal bg-[#F7F7F7] !font-rethink">
        <span className="block md:hidden">
          {" "}
          © {new Date().getFullYear()}
          {" , "}
          {t("footer.ls.mobfooter")}
        </span>
        <span className="hidden md:block">
          © {new Date().getFullYear()}
          {" , "}
          {t("footer.ls.subsidiary")}{" "}
          <a rel="nofollow noopener noreferrer" href="https://www.solidframework.net/" target="_blank">
            <span className="font-bold"> {t("footer.ls.solid_doc")}</span>
          </a>
          {t("footer.ls.and")}
          <a rel="nofollow noopener noreferrer" href="https://www.aspose.com" target="_blank">
            <span className="font-bold">{t("footer.ls.aspose")}</span>{" "}
          </a>
          .
        </span>
      </div>
    </div>
  );
};

export default LegalSimpliFooter;
